import { render } from "./pinch_zoom.vue?vue&type=template&id=0ff638be"
import script from "./pinch_zoom.js?vue&type=script&lang=js&external"
export * from "./pinch_zoom.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__